<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child params-dialog" v-closeSelect>
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" label-width="80px">
        <item-box class="group-item" v-for="(item, index) in dialogForm.groupList" :key="index">
          <template v-slot:title>
            <el-form-item label="分组名称" :prop="`groupList[${index}].groupName`"
              :rules="[{ required: true, message: '请输入分组名称', trigger: 'blur' }]">
              <el-input v-model.trim="item.groupName" placeholder="请输入分组名称"></el-input>
            </el-form-item>
            <div class="btn-box">
              <el-button type="primary" size="mini" :disabled="index === 0"
                @click="handleMoveGroup('up', index)">上移</el-button>
              <el-button type="primary" size="mini" plain :disabled="index === (dialogForm.groupList.length - 1)"
                @click="handleMoveGroup('down', index)">下移</el-button>
              <el-button @click="handleRemoveGroup(index)" :disabled="dialogForm.groupList.length <= 1" type="danger"
                size="mini">删除分组</el-button>
            </div>
          </template>
          <template v-slot:content>
            <item-box class="params-item" v-for="(childItem, childIndex) in item.paramsList" :key="childIndex">
              <template v-slot:title>
                <el-form-item label="参数名称" :prop="`groupList[${index}].paramsList[${childIndex}].paramsName`"
                  :rules="[{ required: true, message: '请输入参数名称', trigger: 'blur' }]">
                  <el-input v-model.trim="childItem.paramsName" placeholder="请输入参数名称"></el-input>
                </el-form-item>
                <div class="btn-box">
                  <el-button type="primary" size="mini" :disabled="childIndex === 0"
                    @click="handleMoveParams('up', index, childIndex)">上移</el-button>
                  <el-button type="primary" size="mini" :disabled="childIndex === (item.paramsList.length - 1)" plain
                    @click="handleMoveParams('down', index, childIndex)">下移</el-button>
                  <el-button @click="handleRemoveParams(index, childIndex)" :disabled="item.paramsList.length <= 1"
                    type="danger" size="mini">删除参数</el-button>
                </div>
              </template>
              <template v-slot:content>
                <el-form-item label="参数类型" class="all" prop="paramsType">
                  <el-select v-model="childItem.paramsType" placeholder="请选择">
                    <el-option label="输入项" value="1" />
                    <el-option label="选择项" value="2" />
                  </el-select>
                </el-form-item>
                <el-form-item v-if="childItem.paramsType === '2'" label=" " class="all clearfix">
                  <div class="content-label required three one-line">可选值</div>
                  <el-form-item :prop="`groupList[${index}].paramsList[${childIndex}].options[${grandChildIndex}]`"
                    :rules="[{ required: true, message: '请输入选项名称', trigger: 'blur' }]" class="options-box all"
                    v-for="(grandChildItem, grandChildIndex) in childItem.options" :key="grandChildIndex">
                    <div class="flex-c-s">
                      <el-input class="flex-grow" v-model.trim="childItem.options[grandChildIndex]"
                        placeholder="请输入选项"></el-input>
                      <div class="btn-box flex-shrink">
                        <el-button type="primary" size="mini" :disabled="grandChildIndex === 0"
                          @click="handleMoveOption('up', index, childIndex, grandChildIndex)">上移</el-button>
                        <el-button type="primary" size="mini" plain
                          :disabled="grandChildIndex === (childItem.options.length - 1)"
                          @click="handleMoveOption('down', index, childIndex, grandChildIndex)">下移</el-button>
                        <el-button @click="handleRemoveOptions(index, childIndex, grandChildIndex)"
                          :disabled="childItem.options.length <= 1" type="danger" size="mini">删除选项</el-button>
                      </div>
                    </div>
                  </el-form-item>
                  <div class="add-btn fl" @click="handleAddOptions(index, childIndex)">+ 添加选项</div>
                </el-form-item>
                <el-form-item label="选项" class="all">
                  <el-checkbox v-model="childItem.required" true-label="1" false-label="0">必填</el-checkbox>
                  <el-checkbox v-model="childItem.search" true-label="1" false-label="0">可搜索</el-checkbox>
                </el-form-item>
              </template>
            </item-box>
            <div class="add-btn" @click="handleAddParams(index)">+ 添加参数</div>
          </template>
        </item-box>
        <div class="add-btn" @click="handleAddGroup">+ 添加分组</div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          "关 闭"
        }}</el-button>
        <el-button type="primary" size="mini" @click="submitForm">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { categoryApi } from "@/api"
export default {
  name: "ParamsDialog",
  props: {
    categoryId: {
      type: [Number, String]
    },
    parentCategoryId: {}
  },
  data() {
    return {
      dialogForm: {
        groupList: [ // 分组列表
          {
            groupName: "", // 分组名称
            paramsList: [
              {
                paramsName: "", // 参数名称
                paramsType: "1", // 参数输入类型  1 输入框 2 选项框
                options: [""], // 参数选项  选择类型时显示
                required: "0", // 是否必填
                search: "0", // 是否可搜索
                value: "" // 参数值
              }
            ]
          }
        ]
      } // 弹框表单
    }
  },
  watch: {
    categoryId: {
      handler: function(val) {
        if (val) {
          this.getParams(val)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 重置参数
    resetForm() {
      this.dialogForm = {
        groupList: [ // 分组列表
          {
            groupName: "", // 分组名称
            paramsList: [
              {
                paramsName: "", // 参数名称
                paramsType: "1", // 参数输入类型  1 输入框 2 选项框
                options: [""], // 参数选项  选择类型时显示
                required: "0", // 是否必填
                search: "0", // 是否可搜索
                value: "" // 参数值
              }
            ]
          }
        ]
      } // 弹框表单
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    // 移动选项
    handleMoveOption(moveType, index, childIndex, grandChildIndex) {
      const target = this.dialogForm.groupList[index].paramsList[childIndex].options[grandChildIndex]
      let targetIndex
      if (moveType === "up") { // 上移
        targetIndex = grandChildIndex - 1
      } else if (moveType === "down") { // 下移
        targetIndex = grandChildIndex + 1
      }
      this.$set(this.dialogForm.groupList[index].paramsList[childIndex].options, grandChildIndex, this.dialogForm.groupList[index].paramsList[childIndex].options[targetIndex])
      this.$set(this.dialogForm.groupList[index].paramsList[childIndex].options, targetIndex, target)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    // 移动参数
    handleMoveParams(moveType, index, childIndex) {
      const target = this.dialogForm.groupList[index].paramsList[childIndex]
      let targetIndex
      if (moveType === "up") { // 上移
        targetIndex = childIndex - 1
      } else if (moveType === "down") { // 下移
        targetIndex = childIndex + 1
      }
      this.$set(this.dialogForm.groupList[index].paramsList, childIndex, this.dialogForm.groupList[index].paramsList[targetIndex])
      this.$set(this.dialogForm.groupList[index].paramsList, targetIndex, target)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    // 移动分组
    handleMoveGroup(moveType, index) {
      const target = this.dialogForm.groupList[index]
      let targetIndex
      if (moveType === "up") { // 上移
        targetIndex = index - 1
      } else if (moveType === "down") { // 下移
        targetIndex = index + 1
      }
      this.$set(this.dialogForm.groupList, index, this.dialogForm.groupList[targetIndex])
      this.$set(this.dialogForm.groupList, targetIndex, target)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    // 获取选项参数
    async getParams(id) {
      const data = await categoryApi.getGroupJsonByCategoryId({ id })
      if (!data.groupJson) {
        if (!this.parentCategoryId) { return }
        const res = await categoryApi.getGroupJsonByCategoryId({ id: this.parentCategoryId })
        if (!res.groupJson) { // 父级分类也无配置参数
          this.$modal.confirm("检测到父级分类尚未配置参数，继续配置将无法继承父级分类的参数配置，是否继续配置？").then(() => {
            return
          }).catch(err => {
            this.$emit("close")
          })
          return
        }
        // 父级分类有配置参数  询问是否继承父级分类的参数配置
        this.$modal.confirm("您当前尚未配置参数，是否先继承父级分类的参数配置？").then(() => {
          this.dialogForm.groupList = res.groupJson
          return
        }).catch(err => {
          return
        })
        return
      }
      this.dialogForm.groupList = data.groupJson
    },
    // 删除选项
    handleRemoveOptions(index, childIndex, grandChildIndex) {
      this.mixinBtnBlur()
      const optionName = this.dialogForm.groupList[index].paramsList[childIndex].options[grandChildIndex]
      const msg = optionName ? `确定删除【${optionName}】这个选项？` : "确定删除该选项？"
      this.$modal.alert(msg).then(data => {
        this.dialogForm.groupList[index].paramsList[childIndex].options.splice(grandChildIndex, 1)
      })
    },
    // 删除参数
    handleRemoveParams(index, childIndex) {
      this.mixinBtnBlur()
      const paramsName = this.dialogForm.groupList[index].paramsList[childIndex].paramsName
      const msg = paramsName ? `确定删除【${paramsName}】这个参数？` : "确定删除该参数？"
      this.$modal.alert(msg).then(data => {
        this.dialogForm.groupList[index].paramsList.splice(childIndex, 1)
      })
    },
    // 删除分组
    handleRemoveGroup(index) {
      this.mixinBtnBlur()
      const groupName = this.dialogForm.groupList[index].groupName
      const msg = groupName ? `确定删除【${groupName}】这个分组？` : "确定删除该分组？"
      this.$modal.alert(msg).then(data => {
        this.dialogForm.groupList.splice(index, 1)
      })
    },
    // 添加选项
    handleAddOptions(index, childIndex) {
      this.dialogForm.groupList[index].paramsList[childIndex].options.push("")
    },
    // 添加参数
    handleAddParams(index) {
      this.dialogForm.groupList[index].paramsList.push({
        paramsName: "", // 参数名称
        paramsType: "1", // 参数输入类型
        options: [""], // 参数选项  选择类型时显示
        required: "0", // 是否必填
        search: "0", // 是否可搜索
        value: "" // 参数值
      })
    },
    // 添加分组
    handleAddGroup() {
      this.dialogForm.groupList.push({
        groupName: "", // 分组名称
        paramsList: [
          {
            paramsName: "", // 参数名称
            paramsType: "1", // 参数输入类型
            options: [""], // 参数选项  选择类型时显示
            required: "0", // 是否必填
            search: "0", // 是否可搜索
            value: "" // 参数值
          }
        ]
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          const params = {
            categoryId: this.categoryId,
            groupJson: JSON.stringify(this.dialogForm.groupList)
          }
          categoryApi.setGroupJsonByCategoryId(params).then(data => {
            this.$modal.msgSuccess(data.msg)
            this.$emit("close")
            this.$emit("successs")
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-box {
  margin-left: 12px;

  .el-button+.el-button {
    margin-left: 12px;
  }
}

::v-deep .group-item {
  .title-box {
    padding: 24px 12px;
  }

  &>.title-box {
    background: #f8f8f8;
  }
}

::v-deep .params-item {
  &>.title-box {
    background: #ecf5ff;
  }
}

// 添加按钮
.add-btn {
  border: 1px dashed #b3d8ff;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  margin-top: 24px;
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.options-box+.options-box {
  margin-top: 24px;
}
</style>